exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creat-title[data-v-d3b1b1c6]{font-size:14px;color:#3c4144;-webkit-line-clamp:2}.creat-description[data-v-d3b1b1c6],.creat-title[data-v-d3b1b1c6]{display:block;display:-webkit-box;max-width:100%;line-height:21px;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.creat-description[data-v-d3b1b1c6]{font-size:12px;color:#777;-webkit-line-clamp:4}", ""]);

// exports
